import  './horarios.css'
import React from "react";
import reactDom from 'react-dom';

export default class Horarios extends React.Component {
    constructor(props) {
        super(props);
        this.state = {  horarios: [] }
        this.filas = this.filas.bind(this);
        this.agregaFila = this.agregaFila.bind(this);
        this.eliminaFila = this.eliminaFila.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.hora= this.hora.bind(this)
    }

    componentDidMount(){
        if(this.props.datosprev !== null){
            this.setState({horarios: this.props.datosprev},()=>{
                this.filas();
            })
        }else{
            this.agregaFila(null)
        }
    }

    agregaFila(e){
        var hr = {horaInicio: '00:00', horaFin: '00:00', dia1:false, dia2:false, dia3:false, dia4:false, dia5:false, dia6:false, dia7:false },
            ac = this.state.horarios;
        if(this.state.horarios.length < 7){
            ac.push(hr)
            this.setState({horarios: ac});
            this.filas();
        }
    }

    eliminaFila(e){
        var elm = e.target, inxE = elm.getAttribute('indx'),
            filas = document.querySelectorAll('.tr_horarios'),
            hrNew =[];
        filas.forEach((f)=>{
            var inps = f.querySelectorAll('input'),
                inxF = f.getAttribute('indx'),
                arr = '{';
            if(inxE !== inxF){
                inps.forEach((i)=>{
                    var nm = i.getAttribute('name'),
                        tipo = i.getAttribute('type'),
                        val = (tipo === 'checkbox' ? i.checked : i.value);
                    if(tipo === 'checkbox'){
                        arr += '"' + nm + '":' + val + ','
                    }else{
                        arr += '"' + nm + '":"' + val + '",'
                    }
                })
                arr = arr.substr(0,arr.length -1) + '}';
                hrNew.push(JSON.parse(arr))
            }
        });
        var bd = document.getElementById('tbl_bd_hr');
        reactDom.unmountComponentAtNode(bd);
        this.setState({horarios: hrNew},()=>{
            this.filas();
            this.props.action(this.state.horarios);
        });
    }

    generaFilas(){
        return this.state.horarios.map((h, index)=>{
            return(
                <tr className='tr_horarios' indx={index} key={index}>
                    <td><input type="checkbox" disabled id={'dia1_' + index} name='dia1' defaultChecked={h.dia1} onChange={(e)=>this.handleChange(e)} /><label htmlFor={'dia1_' + index}><span></span></label></td>
                    <td><input type="checkbox" disabled id={'dia2_' + index} name='dia2' defaultChecked={h.dia2} onChange={(e)=>this.handleChange(e)} /><label htmlFor={'dia2_' + index}><span></span></label></td>
                    <td><input type="checkbox" disabled id={'dia3_' + index} name='dia3' defaultChecked={h.dia3} onChange={(e)=>this.handleChange(e)} /><label htmlFor={'dia3_' + index}><span></span></label></td>
                    <td><input type="checkbox" disabled id={'dia4_' + index} name='dia4' defaultChecked={h.dia4} onChange={(e)=>this.handleChange(e)} /><label htmlFor={'dia4_' + index}><span></span></label></td>
                    <td><input type="checkbox" disabled id={'dia5_' + index} name='dia5' defaultChecked={h.dia5} onChange={(e)=>this.handleChange(e)} /><label htmlFor={'dia5_' + index}><span></span></label></td>
                    <td><input type="checkbox" disabled id={'dia6_' + index} name='dia6' defaultChecked={h.dia6} onChange={(e)=>this.handleChange(e)} /><label htmlFor={'dia6_' + index}><span></span></label></td>
                    <td><input type="checkbox" disabled id={'dia7_' + index} name='dia7' defaultChecked={h.dia7} onChange={(e)=>this.handleChange(e)} /><label htmlFor={'dia7_' + index}><span></span></label></td>
                </tr>
            );
        });
    }

    hora(){
        return this.state.horarios.map((h, index)=>{
            return(
                <tr className='tr_horarios' indx={index} key={index}>
                    <td><input disabled type='time' id={'hrI' + index} name='horarioInicio' defaultValue={h.horarioInicio} onChange={(e)=>this.handleChange(e)} /></td>
                    <td><input disabled type='time' id={'hrF' + index} name='horarioTermino' defaultValue={h.horarioTermino} onChange={(e)=>this.handleChange(e)} /></td>
                </tr>
            );
        });
    }

    filas(){
        var bd = document.getElementById('tbl_bd_hr');
        reactDom.render(this.generaFilas(),bd);

        var bdd = document.getElementById('tbl_bd_hrr');
        reactDom.render(this.hora(),bdd);

    }

    handleChange(e){
        var filas = document.querySelectorAll('.tr_horarios'),
            hrNew =[];
        filas.forEach((f)=>{
            var inps = f.querySelectorAll('input'),
                arr = '{';
            
            inps.forEach((i)=>{
                var nm = i.getAttribute('name'),
                    tipo = i.getAttribute('type'),
                    val = (tipo === 'checkbox' ? i.checked : i.value);
                if(tipo === 'checkbox'){
                    arr += '"' + nm + '":' + val + ','
                }else{
                    arr += '"' + nm + '":"' + val + '",'
                }
            })
            arr = arr.substr(0,arr.length -1) + '}';
            hrNew.push(JSON.parse(arr))
        });
        this.setState({horarios: hrNew},()=>{
            this.props.action(hrNew);
        });
    }

    render(){
        return(
            <div>
                {/* <h3>Combo</h3> */}
                <label className='lbl_md_bl'>Días de trabajo</label>
                <table className='tbl_hr_dias'>
                    <thead>
                        <tr>
                            <th>L</th>
                            <th>M</th>
                            <th>Mi</th>
                            <th>J</th>
                            <th>V</th>
                            <th>S</th>
                            <th>D</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody id='tbl_bd_hr'></tbody>
                </table>
                <label className='lbl_md_bl'>Horarios de trabajo</label>
                <table className='tbl_hr_dias'>
                    <thead> 
                        <th>Hora Inicio</th>
                        <th>Hora Fin</th>
                    </thead>
                    <tbody id='tbl_bd_hrr'></tbody>
                </table>
            </div>
        );
    }
}